module.exports = __webpack_public_path__ + "img/500-fg-left.b4fcfb3.webp";